<template>
  <section v-if="isMotion" class="firmwareDetails_motionArea">
    <div v-if="isMotion && motionDetection" class="motionArea-container">
      <span class="motionArea-container--title">動体検知エリアの設定</span>
      <div
        class="
          motionArea-container--header
          d-flex
          align-center
          justify-space-between
        "
      >
        <v-btn
          class="motionArea-container--addArea"
          x-small
          :disabled="maxAreaNumber"
          @click="addArea"
        >
          <img
            :class="{ 'disabled-btn': maxAreaNumber }"
            src="@/assets/icons/ico_plus.svg"
            alt=""
          />
          <span color="primary">エリア追加</span>
        </v-btn>
        <div class="motionArea-container--counter">{{ areaList.length }}/5</div>
      </div>
      <div v-if="areaList.length" class="motionArea-container--items">
        <div
          v-for="(area, index) in areaList"
          :key="index"
          class="motionArea-item"
          :class="{ 'motionArea-itemActive': area.isActive }"
          @click="selectArea(area, index)"
        >
          <tooltip :classes="'firmwareDetails_tooltip'">
            <template v-slot:activator="{ on, attrs }">
              <div
                v-bind="attrs"
                class="motionArea-item--name text-truncate"
                v-on="on"
              >
                {{ area.name }}
              </div>
            </template>
            <span>{{ area.name }}</span>
          </tooltip>
          <v-menu
            :close-on-content-click="false"
            offset-y
            bottom
            nudge-left="65"
            content-class="firmwareDetails--itemMenu"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                v-bind="attrs"
                text
                class="firmwareDetails_motion--menuBtn"
                :class="{}"
                v-on="on"
              >
                <span class="icon icon-3dots" />
              </v-btn>
            </template>
            <v-list>
              <v-list-item dense @click="handleChangeName(area, index)">
                <v-list-item-icon>
                  <span class="icon icon-pencil" />
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title v-text="'名前の変更'"></v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-list-item dense @click="handleDeleteArea(area, index)">
                <v-list-item-icon>
                  <span class="icon icon-trash" />
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title v-text="'エリアの削除'">
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-menu>
        </div>
      </div>
      <v-btn
        class="motionArea-container--submit"
        :loading="savingAreaList"
        @click="submit"
      >
        保存
      </v-btn>
    </div>
    <clip-rename-dialog
      :open="dialogRenameOpen"
      title="名前の変更"
      :name="updateAreaItem.name"
      :maxlength="10"
      input-case="motionAreaName"
      :existing-names="areaList.map((area) => area.name)"
      :clip-id="updateAreaItem.index"
      @onClose="closeDialogRename"
      @onOk="handleRenameOk"
    />
    <clip-dialog-a
      :open="dialogConfirmOpen"
      :title="dialogConfirmTitle"
      @onClose="closeDialogConfirm"
    >
      <div class="clip_dialog-content firmwareDetails_motionArea-dialog">
        {{ dialogConfirmContent }}
      </div>
      <template v-slot:actions>
        <v-btn
          class="clip_dialog-btn clip_dialog-cancel"
          color="text"
          @click="closeDialogConfirm"
        >
          キャンセル
        </v-btn>
        <v-spacer />
        <v-btn
          class="clip_dialog-btn clip_dialog-delete firmwareDetails-deleteBtn"
          color="text"
          @click="handConfirmOk"
        >
          {{ confirmOkText }}
        </v-btn>
      </template>
    </clip-dialog-a>
  </section>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import ClipDialogA from '@/components/dialogs/ClipDialogA.vue';
import ClipRenameDialog from '@/components/dialogs/ClipInputDialog.vue';
import { calculatePolygans } from '@/utils/helpers';

export default {
  name: 'FirmwareMotionAreas',
  components: { ClipRenameDialog, ClipDialogA },
  props: {
    videoMetadata: {
      type: Object,
      default: () => ({ width: 1280, height: 720 }),
    },
    isMotion: {
      type: Boolean,
      default: false,
    },
    motionDetection: {
      type: Boolean,
      default: false,
    },
    clearAreas: {
      type: Boolean,
      default: false,
    },
    sensitivity: {
      type: Number,
      default: 1,
    },
  },
  data() {
    return {
      areaList: [],
      dialogConfirmOpen: false,
      dialogRenameOpen: false,
      updateAreaItem: {},
      dialogConfirmTitle: '',
      dialogConfirmContent: '',
      confirmOkText: '',
      savingAreaList: false,
    };
  },
  computed: {
    ...mapState({
      newUserCamList: (state) => state.settings.newUserCamList,
      camRecordInfo: (state) => state.settings.camRecordInfo,
    }),
    id() {
      return this.$route.params.id;
    },
    recordSetting() {
      return this.camRecordInfo[String(this.id)];
    },
    maxAreaNumber() {
      return this.areaList.length >= 5;
    },
    videoMetaHeight() {
      return this.videoMetadata.height ? this.videoMetadata.height : 1280;
    },
    videoMetaWidth() {
      return this.videoMetadata.width ? this.videoMetadata.width : 720;
    },
  },
  watch: {
    clearAreas(val) {
      if (val) {
        this.areaList = [];
      }
    },
    recordSetting: {
      deep: true,
      immediate: true,
      handler(val) {
        if (val?.motionSettings?.value?.enable) {
          this.areaList = val.motionSettings.value.rois.map((area, index) => ({
            isActive: index === 0,
            ...area,
            name: area.name.split(' ').join(''),
            index,
            polygonstd: area.polygonstd.split(','),
          }));
          this.$emit('updateAreaList', this.areaList);
        } else {
          this.areaList = [];
          this.$emit('updateAreaList', this.areaList);
        }
      },
    },
  },
  mounted() {},
  methods: {
    ...mapActions('common', ['setIsLoading']),
    ...mapActions('settings', ['saveCameraMotion']),
    addArea() {
      this.areaList.forEach((obj) => (obj['isActive'] = false));
      const index = this.areaList.length;
      const coordinates = {
        top: 25,
        left: 25,
        right: 25,
        bottom: 25,
      };
      // Create new incremental name
      let count = 1;
      let newItemName = '';
      let a = true;
      while (a) {
        newItemName = `動体検知エリア${count}`;
        if (!this.areaList.some((item) => item.name === newItemName)) {
          a = false;
        }
        count++;
      }

      // Create unique id number
      let uniqueNumber = 1;
      if (this.areaList.length) {
        const existingIDs = this.areaList.map((item) => item.id);
        while (existingIDs.includes(uniqueNumber)) {
          uniqueNumber++;
        }
      }
      const { polygonstd } = calculatePolygans({
        videoMetaWidth: this.videoMetaWidth,
        videoMetaHeight: this.videoMetaHeight,
        top: coordinates.top,
        left: coordinates.left,
        bottom: coordinates.bottom,
        right: coordinates.right,
      });

      this.areaList.push({
        index,
        name: newItemName,
        isActive: true,
        id: uniqueNumber,
        polygonstd: [...polygonstd],
        coordinates,
      });
      this.$emit('updateAreaList', this.areaList);
    },
    selectArea(area, index) {
      this.areaList.forEach((obj) => this.$set(obj, 'isActive', false));
      this.$set(this.areaList[index], 'isActive', true);
      this.$emit('updateAreaList', this.areaList);
    },
    handleChangeName(area) {
      this.dialogRenameOpen = true;
      this.updateAreaItem = area;
    },
    handleDisableMotion() {
      this.dialogConfirmOpen = true;
      this.dialogConfirmTitle = '動体検知をOFFにする';
      this.dialogConfirmContent =
        '動体検知をOFFにすると、設定した\n動体検知エリアの設定も削除されます。';
      this.confirmOkText = 'OFFにする';
    },
    handleDeleteArea(area) {
      this.dialogConfirmOpen = true;
      this.updateAreaItem = { ...this.areaList.find((a) => a.id === area.id) };
      this.dialogConfirmTitle = '動体検知エリアを削除する';
      this.dialogConfirmContent = `「${this.updateAreaItem.name}」を\n削除してもよろしいですか？`;
      this.confirmOkText = '削除する';
    },
    handleRenameOk(name) {
      if (name) {
        this.areaList[this.updateAreaItem.index].name = name;
        this.closeDialogRename();
      }
    },
    handConfirmOk() {
      const targetArea = this.areaList.findIndex(
        (a) => a.id === this.updateAreaItem.id
      );
      this.areaList.splice(targetArea, 1);
      this.areaList.forEach((obj, index) => (obj['index'] = index));
      if (this.updateAreaItem.isActive && this.areaList[targetArea]) {
        this.areaList[targetArea].isActive = true;
      } else if (this.updateAreaItem.isActive && this.areaList.length) {
        this.areaList[this.areaList.length - 1].isActive = true;
      }

      this.$emit('updateAreaList', this.areaList);
      this.closeDialogConfirm();
    },
    closeDialogRename() {
      this.updateAreaItem = {};
      this.dialogRenameOpen = false;
    },
    closeDialogConfirm() {
      this.updateAreaItem = {};
      this.dialogConfirmOpen = false;
    },
    clearAreaList() {
      this.areaList = [];
      this.$emit('updateAreaList', this.areaList);
    },
    async submit() {
      this.savingAreaList = true;
      if (!this.areaList.length) {
        this.$emit('disableMotion');
      } else {
        const mappedAreaList = this.areaList.map((area, index) => ({
          ...area,
          id: index,
        }));
        await this.saveCameraMotion({
          sensitivity: this.sensitivity,
          cameraId: this.id,
          areaList: mappedAreaList,
        });
      }
      this.savingAreaList = false;
    },
  },
};
</script>

<style lang="scss">
.firmwareDetails {
  &_motion {
    &Area {
      margin-top: 10px;
      min-width: 220px;
      max-width: 220px;
      position: relative;
      .motionArea-container {
        min-width: 200px;
        padding-left: 20px;
        &--title {
          font-size: 14px;
          font-weight: bold;
        }
        &--header {
          height: 50px;
          margin-top: 15px;
          border-bottom: 1px solid #eeeeee;
        }
        &--addArea {
          box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.16);
          img {
            margin-right: 5px;
          }
          img.disabled-btn {
            opacity: 0.3;
            filter: grayscale(1);
          }
          span {
            font-size: 12px;
            font-weight: bold;
            line-height: 1.08;
          }
        }
        &--counter {
          font-size: 14px;
          font-weight: 600;
          line-height: 1.5;
          color: #989898;
          letter-spacing: 4px;
        }
        &--items {
          .motionArea-item {
            height: 50px;
            display: flex;
            padding: 0 10px;
            align-items: center;
            justify-content: space-between;
            border-bottom: 1px solid #eee;
            cursor: pointer;
            .item-name {
              font-size: 14px;
              font-weight: bold;
            }
            &Active {
              background-color: #f3f3f3;
            }
            &--name {
              max-width: 100%;
              font-size: 14px;
              font-weight: bold;
            }
          }
        }
        &--submit {
          right: 0;
          bottom: -90px;
          position: absolute;
          &.theme--light.v-btn.v-btn--has-bg {
            height: 36px;
            border-radius: 5px;
            box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.16);
            background-color: #0075c2;
            font-size: 14px;
            font-weight: bold;
            font-stretch: normal;
            font-style: normal;
            line-height: 1.14;
            letter-spacing: normal;
            text-align: left;
            color: #fff;
          }
          &.theme--light.v-btn.v-btn--disabled.v-btn--has-bg {
            background-color: #f3f3f3 !important;
            box-shadow: none;
            color: #ccc !important;
          }
        }
      }
      &-dialog {
        white-space: pre;
      }
    }
  }
  &--itemMenu {
    width: 160px;
    padding: 8px 0;
    background-color: white;
    .v-sheet.v-list:not(.v-sheet--outlined) {
      padding: 0;
    }
    .v-sheet.v-card:not(.v-sheet--outlined) {
      width: 300px;
      height: 165px;
      padding: 8px 0;
      border-radius: 10px;
      box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.12);
      background-color: #fff;
    }
    .v-list-item {
      height: 32px;
      min-height: 32px;
    }
    .v-list-item__title {
      font-size: 14px;
      font-weight: normal;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.5;
      letter-spacing: normal;
      text-align: left;
      color: #666;
    }
    .v-list-item__icon {
      margin: 9px 5px 0 0 !important;
      .icon {
        opacity: 0.8;
        color: #707070;
      }
    }
  }
  &-deleteBtn > span {
    font-size: 14px;
    font-weight: bold;
  }
}
</style>
